<template>
  <header class="apple-header" :class="{ 'apple-header--scrolled': scrolled }">
    <div class="apple-header__inner">
      <a href="/" class="apple-header__logo" @click.prevent="toPage('home')">
        <img class="apple-header__logo-img" referrerpolicy="no-referrer" src="@/assets/logo.png" alt="中科悦信" />
        <span class="apple-header__tagline">智慧医疗 承载健康</span>
      </a>
      <nav class="apple-header__nav">
        <a
          v-for="(item, index) in navList"
          :key="index"
          class="apple-header__link"
          :class="{ 'apple-header__link--active': current === index }"
          href="#"
          @click.prevent="toPage(item.url)"
        >
          {{ item.label }}
        </a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "headerPage",
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      scrolled: false,
      navList: [
        { id: 0, label: "企业简介", url: "home" },
        { id: 1, label: "市场分析", url: "analyse" },
        { id: 2, label: "产品介绍", url: "product" },
        { id: 3, label: "核心技术", url: "technology" },
        { id: 4, label: "市场需求", url: "demand" },
        { id: 5, label: "软件下载", url: "xiazai" },
        { id: 6, label: "联系我们", url: "contact" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toPage(url) {
      if (this.$route.name === url) return;
      this.$router.push({ name: url });
    },
    handleScroll() {
      this.scrolled = window.scrollY > 10;
    },
  },
};
</script>

<style scoped>
.apple-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 52px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: saturate(180%) blur(24px);
  -webkit-backdrop-filter: saturate(180%) blur(24px);
  transition: background 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.apple-header--scrolled {
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
}

.apple-header__inner {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 22px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.apple-header__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  padding: 6px 8px;
  margin: -6px -8px;
  border-radius: var(--radius-sm);
  transition: transform var(--transition-fast), opacity var(--transition-fast),
    background var(--transition-fast);
}

.apple-header__logo:hover {
  background: rgba(0, 0, 0, 0.04);
}

.apple-header__logo:active {
  transform: scale(0.96);
  background: rgba(0, 0, 0, 0.06);
}

.apple-header__logo-img {
  height: 28px;
  width: auto;
}

.apple-header__tagline {
  font-size: 14px;
  color: var(--apple-gray);
  letter-spacing: 0.5px;
}

.apple-header__nav {
  display: flex;
  align-items: center;
  gap: 0;
}

.apple-header__link {
  padding: 0 14px;
  height: 36px;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
  color: var(--apple-black);
  text-decoration: none;
  opacity: 0.8;
  border-radius: var(--radius-sm);
  transition: opacity var(--transition-fast), transform var(--transition-fast),
    background var(--transition-fast);
}

.apple-header__link:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}

.apple-header__link:active {
  transform: scale(0.96);
  background: rgba(0, 0, 0, 0.06);
}

.apple-header__link--active {
  opacity: 1;
  font-weight: 500;
}

@media (max-width: 834px) {
  .apple-header__tagline {
    display: none;
  }
  .apple-header__link {
    padding: 0 8px;
    font-size: 13px;
  }
}
</style>
